import { gql } from '@apollo/client';
import { FR_MACHINE_TYPE_FIELDS } from './machineType';

export const MACHINE_SIMPLE_FIELDS = gql`
    fragment MachineSimpleInfoFields on Machine {
        MachineId
        Name
        SerialNbr
        MachineType {
           ...fr_MachineTypeFields
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
`;
